import React from 'react';
import {
  Autocomplete,
  Box,
  Button,
  Card,
  Checkbox,
  colors,
  Container,
  Divider,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  IconButton,
  Popover,
  Radio,
  RadioGroup,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { GoogleSpreadsheet } from 'google-spreadsheet';
import _ from 'lodash';
import AddIcon from '@mui/icons-material/Add';
import GeneralLoader from '../../components/GeneralLoader';
import DialogHTMLEditor from './DialogHTMLEditor';
import DeleteIcon from '@mui/icons-material/Delete';
import PreviewIcon from '@mui/icons-material/Preview';
import toast from 'react-hot-toast';
import { v4 as uuidv4 } from 'uuid';
import DeleteForever from '@mui/icons-material/DeleteForever';
import { useNavigate, useLocation } from 'react-router-dom';
import ReactQuill from 'react-quill';
import mime from 'mime-types';
import Cookies from 'universal-cookie';
import { isFunctionEligible } from '../../helpers/eligibilityChecker';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { decode } from 'jsonwebtoken';
import { fetchWith401Check } from '../../helpers/http';

// Default styles
const pageWidth = {
  width: '100%',
  paddingTop: 2,
  paddingBottom: 2,
  paddingLeft: 4,
  paddingRight: 4,
  margin: 0,
};
const cardStyle = { width: '100%', margin: 1, padding: 3 };
const cardTitleStyle = { width: '100%', margin: 1, padding: 0 };

const acceptedInput = {
  lampiran: 'image/png, image/jpeg, .pdf, .doc, .docx, .pptx',
  data: '.csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel',
  link: 'text',
  foto: 'image/png, image/jpeg',
  video: 'video/mp4,video/x-m4v,video/*',
};

const API_URL = process.env.REACT_APP_STAGE === 'DEVELOPMENT' ? process.env.REACT_APP_API_HOST : process.env.REACT_APP_API_HOST_PROD;

// Config variables
const QuestionForm = ({ type, fetchedAnswers, metadata, userInfo }) => {
  const cookies = new Cookies();
  const inputRefs = React.useRef([]);
  const [authGranted, setAuthGranted] = React.useState(false);
  const [headers, setHeaders] = React.useState([]);
  const [description, setDescription] = React.useState();
  // eslint-disable-next-line
  const [tableProps, setTableProps] = React.useState([]);
  const [answers, setAnswers] = React.useState({ jenis: { value: 'gp' } });
  const [isLoading, setIsLoading] = React.useState(false);
  const [attachmentMeta, setAttachmentMeta] = React.useState({});
  const [fieldErrors, setFieldErrors] = React.useState({});

  const [anchor, setAnchor] = React.useState(null);

  const [multipleTextTemp, setMultipleTextTemp] = React.useState('');
  const [multipleTextTempArray, setMultipleTextTempArray] = React.useState('');

  const [openDialogHTMLEditor, setOpenDialogHTMLEditor] = React.useState({ value: '', status: false, tag: '' });

  const [attachmentType, setAttachmentType] = React.useState('');
  const [docType, setDocType] = React.useState('');
  const [attachmentDescription, setAttachmentDescription] = React.useState('');
  const [isConsentApproved, setIsConsentApproved] = React.useState(['moderation', 'trackChange'].includes(type) ? true : false);

  const [provinces, setProvinces] = React.useState([]);
  const [cities, setCities] = React.useState([]);

  const [institutions, setInstitutions] = React.useState([]);
  const [agencies, setAgencies] = React.useState([]);
  const [docs, setDocs] = React.useState([]);

  const [formLocation, setFormLocation] = React.useState({ province: { label: '', id: '', input_value: '' }, city: { label: '', id: '', input_value: '' } });
  const [formInstitution, setFormInstitution] = React.useState({
    institution: { id: '', label: '', agency_id: '', input_value: '' },
    agency: { id: '', label: '', agency_id: '', input_value: '' },
  });

  const [objectLibraries, setObjectLibraries] = React.useState([]);

  const decoded = decode(cookies.get('token'));

  const [docStatus, setDocStatus] = React.useState('');

  const [rankFlag, setRankFlag] = React.useState('');

  // Config variables
  const SPREADSHEET_ID = process.env.REACT_APP_SPREADSHEET_ID;
  const CLIENT_EMAIL = process.env.REACT_APP_CLIENT_EMAIL;
  const PRIVATE_KEY = process.env.REACT_APP_PRIVATE_KEY.replace(/\n/g, '\n');
  const SHEET_PROPS_ID = 1347492723;
  const doc = new GoogleSpreadsheet(SPREADSHEET_ID);

  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const repoID = queryParams.get('id');

  const appendSpreadsheet = async (row) => {
    try {
      const objectToSend = row;
      await doc.useServiceAccountAuth({
        client_email: CLIENT_EMAIL,
        private_key: PRIVATE_KEY,
      });
      // loads document properties and worksheets

      await doc.loadInfo();

      const sheet = doc.sheetsById[SHEET_PROPS_ID];
      console.log('sheet', sheet);
      const rows = await sheet.getRows();
      objectToSend.id = rows.length + 1;
      const result = await sheet.addRow(objectToSend);
      toast.success('Data saved successfully');
      setIsLoading(false);
      setTimeout(() => {
        // alert(`${location.pathname}/success`);
        navigate(`${location.pathname}/success`);
      }, 1000);
    } catch (e) {
      console.error('Error: ', e);
      setIsLoading(false);
    }
  };

  const handleDialogClose = () => {
    setOpenDialogHTMLEditor({ ...openDialogHTMLEditor, status: false });
  };

  const getProps = async () => {
    try {
      await doc.loadInfo();
      const sheetData = await doc.sheetsById[SHEET_PROPS_ID];
      await sheetData.loadCells(); // Prevent This cell has not been loaded yet
      const B2 = await sheetData.getCellByA1('B2');
      setTableProps(JSON.parse(B2.value));
      setHeaders(JSON.parse(B2.value).data?.attributes?.headers);
      setDescription(JSON.parse(B2.value).data?.attributes?.description);
    } catch (error) {
      alert(error.message);
    }
  };

  const fetchDocs = async () => {
    fetchWith401Check(`${API_URL}/tableprops/docs`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${cookies.get('token')}` },
      referrer: 'no-referrer',
    })
      .then(function (response) {
        if (response.ok) {
          return response.json();
        }
        return Promise.reject(response);
      })
      .then(function (response) {
        const docsData = response?.responses || [];
        setDocs(docsData);
      })
      .catch(function (err) {
        return toast.error(err.message);
      });
  };

  const fetchInstitutions = async () => {
    fetchWith401Check(`${API_URL}/tableprops/institutions`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${cookies.get('token')}` },
      referrer: 'no-referrer',
    })
      .then(function (response) {
        if (response.ok) {
          return response.json();
        }
        return Promise.reject(response);
      })
      .then(function (response) {
        const institutionsData = response?.responses || [];
        setInstitutions(institutionsData);
      })
      .catch(function (err) {
        return toast.error(err.message);
      });
  };

  const fetchAgencies = async () => {
    if (_.isEmpty(formInstitution.institution) && !isConsentApproved) return;
    fetchWith401Check(`${API_URL}/tableprops/agencies?agency_id=${formInstitution?.institution?.agency_id}`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${cookies.get('token')}` },
      referrer: 'no-referrer',
    })
      .then(function (response) {
        if (response.ok) {
          return response.json();
        }
        return Promise.reject(response);
      })
      .then(function (response) {
        const agenciesData = response?.responses || [];
        setAgencies(agenciesData);
      })
      .catch(function (err) {
        return toast.error(err.message);
      });
  };

  const fetchProvinces = async () => {
    fetchWith401Check(`${API_URL}/tableprops/provinces`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${cookies.get('token')}` },
      referrer: 'no-referrer',
    })
      .then(function (response) {
        if (response.ok) {
          return response.json();
        }
        return Promise.reject(response);
      })
      .then(function (response) {
        const provincesData = response?.responses || [];
        setProvinces(provincesData);
      })
      .catch(function (err) {
        return toast.error(err.message);
      })
      .finally(() => {
        fetchInstitutions();
      });
  };

  const fetchCities = async () => {
    if (_.isEmpty(formLocation.province) && isConsentApproved) return;
    fetchWith401Check(`${API_URL}/tableprops/cities?province_id=${formLocation?.province?.id}`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${cookies.get('token')}` },
      referrer: 'no-referrer',
    })
      .then(function (response) {
        if (response.ok) {
          return response.json();
        }
        return Promise.reject(response);
      })
      .then(function (response) {
        const citiesData = response?.responses || [];
        setCities(citiesData);
      })
      .catch(function (err) {
        return toast.error(err.message);
      });
  };

  const fetchProps = async () => {
    setIsLoading(true);
    fetchWith401Check(`${API_URL}/tableprops?type=table_headers`, {
      method: 'GET',
      // body: 'title=' + encodeURIComponent('My awesome new article') + '&body=' + encodeURIComponent('This is the text of my article'),
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${cookies.get('token')}` },
      referrer: 'no-referrer',
    })
      .then(function (response) {
        if (response.ok) {
          return response.json();
        }
        setIsLoading(false);
        return Promise.reject(response);
      })
      .then(function (response) {
        const headerData = response.data;
        setTableProps(headerData);
        setHeaders(headerData.data?.attributes?.headers);
        setDescription(headerData.data?.attributes?.description);
        setIsLoading(false);
      })
      .catch(function (err) {
        setIsLoading(false);
        return alert(err.message);
      })
      .finally(() => {
        {
          fetchProvinces();
        }
      });
  };

  const initAuth = async () => {
    try {
      // Initialize Auth - see https://theoephraim.github.io/node-google-spreadsheet/#/getting-started/authentication
      await doc.useServiceAccountAuth({
        // env var values are copied from service account credentials generated by google
        // see "Authentication" section in docs for more info
        client_email: CLIENT_EMAIL,
        private_key: PRIVATE_KEY,
      });

      // const sheetData = await doc.sheetsByIndex[0];
      // const rowsData = await sheetData.getRows();
      // await sheetData.loadHeaderRow();

      // setHeaders(sheetData.headerValues);
      // setSheet(sheetData);
      // setRows(rowsData);
      setAuthGranted(true);
    } catch (error) {
      alert(error.message);
      setAuthGranted(false);
    }
  };

  const uploadFileToMinio = (file) => {
    return new Promise((resolve, reject) => {
      setIsLoading(true);
      const formData = new FormData();
      const extension = '.' + mime.extension(file.type);

      // extension = '.docx';
      // if (file.type === 'image/jpeg') extension = '.jpg';
      // if (file.type === 'image/png') extension = '.png';
      // if (file.type === 'application/pdf') extension = '.pdf';
      // if (file.type === "application/vnd.ms-excel") extension = '.xlsx';

      const uuid = uuidv4();
      const newFilename = `${uuid}${extension}`;
      let newFile = new File([file], newFilename, {
        type: file.type,
        lastModified: Date.now(),
      });
      formData.append('upload', newFile);

      fetchWith401Check(`${API_URL}/uploadfile`, {
        method: 'POST',
        body: formData,
        headers: { Authorization: `Bearer ${cookies.get('token')}` },
      })
        .then((response) => response.json())
        .then((result) => {
          console.log(result);
          resolve(`${API_URL}/download?filename=keshif/${result.originalname}`);
          setIsLoading(false);
        })
        .catch((error) => {
          setIsLoading(false);
          reject('Upload failed');
          console.error('Error:', error);
        });
    });
  };

  const handleChooseFile = async (e, item) => {
    const file = e.target.files[0];
    const { tag } = item;

    let fileTotalLimit = 50;
    if (item.type === 'thumbnail') fileTotalLimit = 2;

    if (file?.name) {
      const MAX_FILE_SIZE = 5120;
      const fileSize = file.size;

      if (fileSize / 5120 > MAX_FILE_SIZE) return toast.error('File chosen is exceeding the maximum size of 50MB');
      // const tmppath = URL.createObjectURL(file);
      const paths = answers[tag]?.value || [];
      console.log({ type: item.type, fileTotalLimit, length: paths.length });
      if (paths.length + 1 > fileTotalLimit) return toast.error('You have reached the maximum file upload');
      const image_path = await uploadFileToMinio(file);
      paths.push(image_path);
      setAnswers({ ...answers, [tag]: { value: paths } });
    }
  };

  const handleCustomAttachmentChooseFile = async (e, item) => {
    const file = e.target.files[0];
    const { tag } = item;

    let fileTotalLimit = 50;
    if (item.type === 'thumbnail') fileTotalLimit = 1;

    if (file?.name) {
      const MAX_FILE_SIZE = 5120;
      const fileSize = file.size;

      if (fileSize / 5120 > MAX_FILE_SIZE) return toast.error('File chosen is exceeding the maximum size of 50MB');
      // const tmppath = URL.createObjectURL(file);
      const paths = answers[tag]?.value || [];
      if (paths.length + 1 > fileTotalLimit) return toast.error('You have reached the maximum file upload');
      const file_path = await uploadFileToMinio(file);
      paths.push({ path: file_path, type: attachmentType, description: attachmentDescription, doc_type: docType });
      setAnswers({ ...answers, [tag]: { value: paths } });
      // setAttachmentDescription('');
      // setDocType('');
      // setAttachmentType('');
    }
  };

  const handleSubmit = async () => {
    const _fieldErrors = {};
    const messageAlert = [];
    const selectedFormCategory = answers?.jenis?.value;

    if (!selectedFormCategory) return toast.error(`No category found, please contact your administrator [the key used: jenis]`); //HARDCODED

    // console.log(selectedFormCategory);
    headers.forEach((item) => {
      // console.log(item.category);
      // console.log(selectedFormCategory);
      if (item.category && item.category.includes(selectedFormCategory)) {
        // console.log('check', { category: item.category, typeselected: answers?.jenis?.value });
        if (type === 'moderation') {
          if (item.isRequired && item.isEnabled && _.isEmpty(answers[item.tag]?.value)) {
            _fieldErrors[item.tag] = true;
            messageAlert.push(item.tag);
          }
        } else {
          if (item.isRequired && item.isEnabled && item.isVisible && _.isEmpty(answers[item.tag]?.value)) {
            _fieldErrors[item.tag] = true;
            messageAlert.push(item.tag);
          }
        }
      }
    });

    setFieldErrors({ ..._fieldErrors });

    if (!_.isEmpty(_fieldErrors)) {
      alert(`Please add ${messageAlert}`);
      return toast.error('Please fill all required fields.');
    }

    setIsLoading(true);

    const objectToSend = {};
    for (const [key, value] of Object.entries(answers)) {
      // if (isArray(value.value)) {
      //   objectToSend[key] = JSON.stringify(value.value);
      // } else if (typeof value.value === 'string' || value.value instanceof String) {
      //   objectToSend[key] = value.value;
      // } else {
      //   objectToSend[key] = JSON.stringify(value.value.toString());
      // }
      objectToSend[key] = value.value;
    }

    const uuid = uuidv4();

    if (type === 'moderation') {
      try {
        const finalRankFlag = answers?.type_of_gp?.value === 'sdg_awards' ? rankFlag : '';
        const requestOptions = {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${cookies.get('token')}` },
          body: JSON.stringify({ data: { ...objectToSend, rank_flag: finalRankFlag }, status: docStatus, id: metadata.id }),
        };

        // return console.log(requestOptions.body);

        fetchWith401Check(`${API_URL}/tabledatas`, requestOptions)
          .then((response) => response.json())
          .then((result) => {
            if (!result.error) {
              toast.success('Data saved successfully');
              if (!type === 'moderation')
                setTimeout(() => {
                  navigate(`${location.pathname}/success`);
                }, 1000);
            } else {
              throw new Error(result?.errors?.message || 'Something wrong happenned');
            }
          })
          .catch((error) => {
            toast.error(error.message);
          });
      } catch (error) {
        toast.error(error.message);
        setIsLoading(false);
      } finally {
        setIsLoading(false);
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      }
    } else {
      try {
        objectToSend.id = uuid;
        fetchWith401Check(`${API_URL}/tabledatas`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${cookies.get('token')}` },
          body: JSON.stringify({ data: objectToSend, created_by: decoded.username, status: 'new' }),
        })
          .then((response) => response.json())
          .then((result) => {
            if (!result.error) {
              toast.success('Data saved successfully');
              setTimeout(() => {
                // alert(`${location.pathname}/success`);
                navigate(`${location.pathname}/success`);
              }, 1000);
            } else {
              throw new Error(result?.errors?.message || 'Something wrong happenned');
            }
          })
          .catch((error) => {
            toast.error(error.message);
          });
      } catch (error) {
        toast.error(error.message);
        setIsLoading(false);
      } finally {
        setIsLoading(false);
      }
    }
  };

  const handleRemoveAttachment = (path, tag) => {
    const prevAnswers = answers[tag].value;
    const indexTarget = prevAnswers.indexOf(path);
    prevAnswers.splice(indexTarget, 1);
    setAnswers({ ...answers, [tag]: { value: prevAnswers } });
  };

  // React.useEffect(() => {
  //   initAuth();
  // }, []);

  // React.useEffect(() => {
  //   if (authGranted) getProps();
  // }, [authGranted]);

  const getAcceptedInput = (item, index) => {
    const optionsIndex = _.findIndex(item.options, (option) => {
      return option.key === attachmentType;
    });

    let _acceptedInput = '';

    if (optionsIndex > -1) {
      _acceptedInput = item.options[optionsIndex].acceptedInput;
    }

    // console.log('check accepted input', _acceptedInput);
    return _acceptedInput;
  };

  React.useEffect(() => {
    fetchProps();
  }, []);

  React.useEffect(() => {
    setFormLocation({ ...formLocation, city: { label: '', id: '' } });
    fetchCities();
  }, [formLocation.province]);

  React.useEffect(() => {
    setFormInstitution({ ...formInstitution, agency: { label: '', id: '' } });
    fetchAgencies();
  }, [formInstitution.institution]);

  React.useEffect(() => {
    fetchDocs();
  }, []);

  React.useEffect(() => {
    if (!_.isEmpty(fetchedAnswers)) {
      setDocType(fetchedAnswers.jenis.value);
      setAnswers({ ...answers, ...fetchedAnswers });
      setDocStatus(metadata.status);
      setRankFlag(metadata.rank_flag);
    }
  }, []);

  const doLogOut = () => {
    const cookies = new Cookies();
    cookies.remove('token', { path: '/' });
    window.location.href = '/';
  };

  const doDeleteRepo = () => {
    if (!repoID) return toast.error('No repo ID found');
    fetchWith401Check(`${API_URL}/tabledatas/single/${repoID}`, {
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${cookies.get('token')}` },
    })
      .then((response) => response.json())
      .then((result) => {
        if (!result.error) {
          toast.success('Data deleted successfully');
          setTimeout(() => {
            navigate(-1);
            // setTimeout(() => {
            //   window.location.reload();
            // }, 1000);
          }, 500);
        } else {
          throw new Error(result?.errors?.message || 'Something wrong happenned');
        }
      })
      .catch((error) => {
        toast.error(error.message);
      });
  };

  const getMaxInputLength = (type) => {
    if (type === 'longtext') return 200;
    if (type === 'url') return 300;
    return 100;
  };

  const isShown = (item, type) => {
    if (type === 'moderation') {
      if (item?.isEnabled) return true;
      return false;
    } else {
      if (item?.isVisible && item?.isEnabled) return true;
      return false;
    }
  };

  console.log('check answers', answers);

  return (
    <Box sx={{ backgroundColor: colors.blue[100], maxHeight: '100vh', overflow: 'scroll' }}>
      <Container maxWidth='md'>
        <Stack direction='column' alignItems='center' m={2} sx={pageWidth}>
          <Card sx={cardTitleStyle}>
            <Stack style={{ backgroundColor: colors.blue[400], width: '100%', height: 14 }} />
            <Stack direction='column' spacing={1} p={4}>
              <Typography variant='h5' sx={{ fontWeight: 700 }}>
                UN Indonesia’s Document Repository
              </Typography>
              <Typography variant='body2'>{description}</Typography>
              <Divider />
              <Typography variant='caption'>Field marked with "*" symbol are required</Typography>
            </Stack>
          </Card>

          <Card sx={cardTitleStyle}>
            <Stack style={{ backgroundColor: colors.amber[400], width: '100%', height: 14 }} />
            <Stack direction='column' spacing={1} p={4}>
              <Typography variant='body2' sx={{ fontWeight: 'bold' }}>
                Pernyataan Persetujuan (Consent Statement)*
              </Typography>
              <Typography variant='body2'>
                By submitting a document (report, publication, assessment or other contribution), I give my full consent to the United Nations to read and make
                the document available to the public.
              </Typography>
              <Divider />
              <Stack direction='row' alignItems='center'>
                <Checkbox checked={isConsentApproved ? true : false} onChange={(e) => setIsConsentApproved(!isConsentApproved)} />
                <Typography variant='body2'>Approve</Typography>
              </Stack>
            </Stack>
          </Card>

          {<GeneralLoader isLoading={isLoading} />}

          {!_.isEmpty(headers) &&
            isConsentApproved &&
            headers.map((item, index) => (
              <>
                {item.type === 'section' && item?.category?.includes(answers?.jenis?.value) && (
                  <Card key={index} sx={cardStyle}>
                    <Stack direction='column' p={1}>
                      <Typography variant='h6'>{item.label}</Typography>
                    </Stack>
                  </Card>
                )}
                {(item?.category?.includes(answers?.jenis?.value) || item.tag === 'jenis') && isShown(item, type) && item.type !== 'section' && (
                  <Card key={index} sx={cardStyle}>
                    <Stack direction='column' p={1}>
                      {item.type === 'text' && (
                        <Stack direction='column' p={1}>
                          <Typography variant='body2'>
                            {item.label}
                            {item.isRequired && '*'}
                          </Typography>
                          <TextField
                            error={fieldErrors[item.tag]}
                            variant='standard'
                            required={item.isRequired ? true : false}
                            type={item.validationType === 'longtext' ? 'text' : item.validationType}
                            value={answers[item.tag]?.value}
                            onChange={(e) => setAnswers({ ...answers, [item.tag]: { value: e.currentTarget.value } })}
                            focused
                            placeholder={`Your answer, max ${getMaxInputLength(item.validationType)} characters`}
                            color='secondary'
                            multiline={item.validationType === 'longtext'}
                            rows={item.validationType === 'longtext' ? 6 : 1}
                            inputProps={{
                              maxLength: getMaxInputLength(item.validationType),
                              min: item.validationType === 'date' ? '2017-01-01' : undefined,
                            }}
                          />
                        </Stack>
                      )}
                      {item.type === 'multiple-text' && (
                        <Stack direction='column' spacing={2}>
                          <Stack direction='row' spacing={2} alignItems='center' justifyContent='center'>
                            <Stack sx={{ flex: 3 }}>
                              <TextField
                                error={fieldErrors[item.tag]}
                                variant='standard'
                                required={item.isRequired ? true : false}
                                label={item.label}
                                type={item.validationType}
                                value={multipleTextTemp}
                                onChange={(e) => setMultipleTextTemp(e.currentTarget.value)}
                                focused
                                placeholder='Your answer'
                                color='secondary'
                              />
                            </Stack>
                            <Stack sx={{ flex: 1 }}>
                              <Button
                                onClick={() => {
                                  if (multipleTextTemp) {
                                    const items = answers[item.tag]?.value || [];
                                    items.push(multipleTextTemp);
                                    setAnswers({ ...answers, [item.tag]: { value: items } });
                                    setMultipleTextTemp('');
                                  } else {
                                    toast.error('Please fill the item text');
                                  }
                                }}
                              >
                                Add Item
                              </Button>
                            </Stack>
                          </Stack>
                          <Stack>
                            {!_.isEmpty(answers[item.tag]) ? (
                              <Typography variant='caption'>Items</Typography>
                            ) : (
                              <Typography variant='caption'>Please add some item first</Typography>
                            )}

                            {!_.isEmpty(answers[item.tag]?.value) &&
                              answers[item.tag]?.value.map((item_multiple, item_multiple_index) => (
                                <Stack direction='row' spacing={1} alignItems='center'>
                                  <IconButton color='primary' onClick={() => console.log('test')} aria-label='Delete'>
                                    <DeleteForever
                                      onClick={() => {
                                        const prevItems = answers[item.tag].value;
                                        prevItems.splice(item_multiple_index, 1);
                                        setAnswers({ ...answers, [item.tag]: { value: prevItems } });
                                      }}
                                      sx={{ color: 'red' }}
                                    />
                                  </IconButton>
                                  <Typography variant='body2'>{item_multiple}</Typography>
                                </Stack>
                              ))}

                            {/* <Typography>{JSON.stringify(answers[item.tag]?.value)}</Typography> */}
                          </Stack>
                        </Stack>
                      )}
                      {item.type === 'institution_agency' && (
                        <Stack direction='column' spacing={1} sx={{ overflow: 'scroll', minHeight: 300 }}>
                          <Stack direction='column' spacing={1} mb={2}>
                            <Typography variant='body2'>
                              {item.label}
                              {item.isRequired && ' *'}
                            </Typography>
                          </Stack>

                          <Stack direction='column' spacing={1}>
                            <Autocomplete
                              ListboxProps={{ style: { maxHeight: 150 } }}
                              disablePortal
                              disabled={_.isEmpty(institutions)}
                              id='combo-box-institutions'
                              options={institutions}
                              sx={{ width: 400 }}
                              renderInput={(params) => <TextField {...params} label='Pilih Instansi (choose institution)' />}
                              required
                              onChange={(event, newValue) => {
                                if (!newValue)
                                  return setFormInstitution({
                                    ...formInstitution,
                                    institution: { id: '', label: '', input_value: '', agency_id: '' },
                                    agency: { id: '', label: '', input_value: '', agency_id: '' },
                                  });
                                setFormInstitution({
                                  ...formInstitution,
                                  institution: {
                                    id: newValue.key,
                                    label: newValue.label,
                                    agency_id: newValue.agency_id,
                                    input_value: newValue.label,
                                    is_other: newValue.is_other,
                                  },
                                });
                              }}
                              value={formInstitution?.institution?.label}
                              inputValue={formInstitution?.institution?.input_value}
                              onInputChange={(event, newInputValue) => {
                                setFormInstitution({ ...formInstitution, institution: { ...formInstitution.institution, input_value: newInputValue } });
                              }}
                            />
                          </Stack>
                          <Stack direction='column' spacing={1}>
                            <Autocomplete
                              ListboxProps={{ style: { maxHeight: 150 } }}
                              required
                              disabled={_.isEmpty(agencies)}
                              disablePortal
                              id='combo-box-agencies'
                              options={agencies}
                              sx={{ width: 400 }}
                              renderInput={(params) => <TextField {...params} label='Pilih nama agency (choose agency name)' />}
                              onChange={(event, newValue) => {
                                if (!newValue) return setFormInstitution({ ...formInstitution, agency: { id: '', label: '', input_value: '', agency_id: '' } });
                                setFormInstitution({
                                  ...formInstitution,
                                  agency: {
                                    id: newValue.key,
                                    label: newValue.label,
                                    agency_id: newValue.agency_id,
                                    input_value: newValue.label,
                                    is_other: newValue.is_other,
                                  },
                                });
                              }}
                              value={formInstitution?.agency?.label}
                              inputValue={formInstitution?.agency?.input_value}
                              onInputChange={(event, newInputValue) => {
                                setFormInstitution({ ...formInstitution, agency: { ...formInstitution.agency, input_value: newInputValue } });
                              }}
                            />
                          </Stack>
                          <Stack direction='column' spacing={2} justifyContent='center' alignItems='flex-start' m={2} p={2}>
                            {/* {JSON.stringify(answers[item.tag])} */}
                            {/* 689 740 */}
                            {answers[item.tag]?.value && (
                              <>
                                <Typography>Selected institution:</Typography>
                                {answers[item.tag]?.value?.map((item_options, index_options) => (
                                  <Stack direction='row' spacing={1} alignItems='center'>
                                    <IconButton
                                      aria-label='Delete'
                                      color='primary'
                                      onClick={() => {
                                        const currentValues = answers[item.tag]?.value;
                                        currentValues.splice(index_options, 1);
                                        setAnswers({ ...answers, [item.tag]: { value: currentValues } });
                                      }}
                                    >
                                      <DeleteIcon sx={{ color: colors.red[400] }} />
                                    </IconButton>
                                    <Typography sx={{ fontWeight: '700' }}>
                                      Institution type: {item_options?.institution?.label}, Agency:{' '}
                                      {item_options.agency?.label || item_options.agency?.other?.toString()}
                                    </Typography>
                                  </Stack>
                                ))}
                              </>
                            )}
                          </Stack>
                          <Stack>
                            {formInstitution.agency?.is_other && (
                              <Stack direction='column' spacing={2}>
                                <Stack direction='row' spacing={2} alignItems='center' justifyContent='center'>
                                  <Stack sx={{ flex: 3 }}>
                                    <TextField
                                      // error={fieldErrors[item.tag]}
                                      variant='standard'
                                      required={item.isRequired ? true : false}
                                      label='Agencies'
                                      type='Text'
                                      value={multipleTextTemp}
                                      onChange={(e) => setMultipleTextTemp(e.currentTarget.value)}
                                      focused
                                      placeholder='Your answer'
                                      color='secondary'
                                    />
                                  </Stack>
                                  <Stack sx={{ flex: 1 }}>
                                    <Button
                                      onClick={() => {
                                        if (multipleTextTemp) {
                                          // const items = !_.isEmpty(formInstitution?.agency?.other) ? formInstitution?.agency?.other : [];
                                          // items.push(multipleTextTemp);

                                          // const currentFormInstitution = formInstitution;
                                          // currentFormInstitution.agency = {
                                          //   ...currentFormInstitution.agency,
                                          //   other: multipleTextTemp,
                                          //   label: 'other',
                                          //   id: 'other',
                                          // };

                                          // const values = !_.isEmpty(answers[item.tag]?.value) ? answers[item.tag].value : [];
                                          // values.push(currentFormInstitution);

                                          // // "id":"Pemda_2","label":" BALI","agency_id":"pemerintah_daerah","input_value":" BALI"
                                          // return alert(JSON.stringify(values));
                                          // setAnswers({ ...answers, [item.tag]: { value: values } });
                                          // setMultipleTextTemp('');

                                          const currentValues = answers[item.tag]?.value || [];
                                          const items = multipleTextTempArray || [];
                                          items.push(multipleTextTemp);
                                          setMultipleTextTempArray(items);
                                          setMultipleTextTemp('');
                                        } else {
                                          toast.error('Please fill the item text');
                                        }
                                      }}
                                    >
                                      Add Agency Item
                                    </Button>
                                  </Stack>
                                </Stack>
                                <Stack>
                                  {!_.isEmpty(multipleTextTempArray) ? (
                                    <Stack direction='column' spacing={1}>
                                      <Typography variant='caption'>Items</Typography>
                                      {multipleTextTempArray.map((item, index) => (
                                        <Stack direction='row' alignItems='center' spacing={1}>
                                          <IconButton
                                            color='primary'
                                            onClick={() => {
                                              const newItems = multipleTextTempArray;
                                              newItems.splice(index, 1);
                                              setMultipleTextTempArray([...newItems]);
                                            }}
                                            aria-label='Delete'
                                          >
                                            <DeleteForever sx={{ color: 'red' }} />
                                          </IconButton>
                                          <Typography variant='body2'>{item}</Typography>
                                        </Stack>
                                      ))}
                                    </Stack>
                                  ) : (
                                    <Typography variant='caption'>Please add some agency item first</Typography>
                                  )}

                                  {/* {!_.isEmpty(answers[item.tag]?.value?.agency?.other) &&
                                    answers[item.tag]?.value?.agency?.other.map((item_multiple, item_multiple_index) => (
                                      <Stack direction='row' spacing={1} alignItems='center'>
                                        <IconButton color='primary' onClick={() => console.log('test')} aria-label='Delete'>
                                          <DeleteForever
                                            onClick={() => {
                                              const prevItems = answers[item.tag].value;
                                              prevItems.splice(item_multiple_index, 1);
                                              setAnswers({ ...answers, [item.tag]: { value: prevItems } });
                                            }}
                                            sx={{ color: 'red' }}
                                          />
                                        </IconButton>
                                        <Typography variant='body2'>{item_multiple}</Typography>
                                      </Stack>
                                    ))} */}
                                </Stack>
                              </Stack>
                            )}
                          </Stack>
                          <Stack direction='column' spacing={2} justifyContent='center' alignItems='center'>
                            <Button
                              disabled={!formInstitution?.institution?.id || (!formInstitution?.agency?.id && !multipleTextTempArray)}
                              startIcon={<AddIcon />}
                              onClick={() => {
                                const values = !_.isEmpty(answers[item.tag]?.value) ? answers[item.tag]?.value : [];
                                const newFormInstitution = formInstitution;
                                if (!_.isEmpty(multipleTextTempArray)) {
                                  newFormInstitution.agency = {
                                    id: 'other',
                                    other: multipleTextTempArray,
                                  };
                                }
                                values.push(newFormInstitution);
                                setAnswers({ ...answers, [item.tag]: { value: values } });
                                setFormInstitution({
                                  ...formInstitution,
                                  institution: { id: '', label: '', input_value: '', agency_id: '' },
                                  agency: { id: '', label: '', input_value: '', agency_id: '' },
                                });
                                setMultipleTextTempArray([]);
                              }}
                            >
                              Add Institution & Agency
                            </Button>
                            <Typography variant='caption'>
                              Please choose institution and agency then click add to save your institution/agency selection
                            </Typography>
                            <GeneralLoader isLoading={isLoading && item.tag === attachmentMeta.tag} />
                          </Stack>
                        </Stack>
                      )}
                      {item.type === 'html' && (
                        <Stack
                          direction='column'
                          spacing={1}
                          onClick={() => setOpenDialogHTMLEditor({ ...openDialogHTMLEditor, status: true, tag: [item.tag], value: answers[item.tag]?.value })}
                        >
                          <Typography variant='caption' sx={{ color: fieldErrors[item.tag] ? 'red' : 'black' }}>
                            {item.label}
                          </Typography>
                          <TextField
                            sx={{
                              '& .MuiInputBase-root': {
                                height: 80,
                              },
                            }}
                            variant='standard'
                            required={item.isRequired ? true : false}
                            label='Click to edit'
                            type='text'
                            value={answers[item.tag]?.value ? 'Click to edit content' : 'Click to add content'}
                            focused
                            onChange={() => console.log('update')}
                            placeholder='Your answer'
                            color='secondary'
                            style={{ cursor: 'pointer', minHeight: 100 }}
                            disabled={true}
                          />
                          {answers[item.tag]?.value && <ReactQuill value={answers[item.tag]?.value} readOnly={true} theme={'bubble'} />}
                        </Stack>
                      )}
                      {['thumbnail'].includes(item.type) && (
                        <Stack direction='column' spacing={1}>
                          {item.type === 'attachment' ? (
                            <input
                              id={item.tag}
                              accept='image/png, image/jpeg, .pdf, .doc, .docx'
                              type='file'
                              ref={(ref) => {
                                inputRefs.current[index] = ref; // took this from your guide's example.
                              }}
                              style={{ display: 'none' }}
                              onChange={(e) => handleChooseFile(e, item)}
                            />
                          ) : (
                            <input
                              id={item.tag}
                              accept='image/png, image/jpeg'
                              type='file'
                              ref={(ref) => {
                                inputRefs.current[index] = ref; // took this from your guide's example.
                              }}
                              style={{ display: 'none' }}
                              onChange={(e) => handleChooseFile(e, item)}
                            />
                          )}

                          <Typography variant='body2' style={{ color: fieldErrors[item.tag] ? 'red' : 'block' }}>
                            {item.label} {item.isRequired && '*'}
                          </Typography>
                          {item.type === 'attachment' && <Typography variant='caption'>Maximum size is 50Mb.</Typography>}
                          {item.type === 'thumbnail' && (
                            <Typography variant='caption'>Maximum size is 50Mb. You can upload only 1 file for thumbnail.</Typography>
                          )}

                          {_.isEmpty(answers[item.tag]?.value) ? (
                            <Typography variant='caption'>No attachment found, you can add your attachment by click the add button below.</Typography>
                          ) : (
                            <Stack direction='row' spacing={2} sx={{ overflow: 'scroll', scrollbarColor: colors.blue[400] }}>
                              {!_.isEmpty(answers[item.tag]?.value) &&
                                answers[item.tag]?.value?.map((item_attachment, index) => (
                                  <Stack key={index} direction='column' alignItems='center'>
                                    <img
                                      alt='cover'
                                      src={item_attachment}
                                      width={100}
                                      height={100}
                                      style={{ objectFit: 'cover' }}
                                      onError={(event) => {
                                        event.target.src = '/assets/document_placeholder.jpg';
                                        event.onerror = null;
                                      }}
                                    />
                                    <IconButton onClick={() => handleRemoveAttachment(item_attachment, item.tag)} aria-label='Delete' color='primary'>
                                      <DeleteIcon sx={{ color: colors.red[400] }} />
                                    </IconButton>
                                  </Stack>
                                ))}
                            </Stack>
                          )}
                          <Stack direction='column' spacing={2} justifyContent='center' alignItems='center'>
                            <Button
                              startIcon={<AddIcon />}
                              onClick={() => {
                                setAttachmentMeta({ ...attachmentMeta, tag: item.tag, length: answers[item.tag]?.value?.length });
                                inputRefs.current[index].click();
                              }}
                            >
                              Add Photo
                            </Button>
                            <GeneralLoader isLoading={isLoading && item.tag === attachmentMeta.tag} />
                          </Stack>
                        </Stack>
                      )}
                      {['attachment'].includes(item.type) && (
                        <Stack direction='column' spacing={1}>
                          <input
                            id={item.tag}
                            accept={getAcceptedInput(item, index)}
                            type='file'
                            ref={(ref) => {
                              inputRefs.current[index] = ref; // took this from your guide's example.
                            }}
                            style={{ display: 'none' }}
                            onChange={(e) => handleCustomAttachmentChooseFile(e, item)}
                          />

                          <Typography variant='body2'>
                            {item.label} {item.isRequired && '*'}
                          </Typography>
                          {item.type === 'attachment' && <Typography variant='caption'>Maximum size is 50Mb.</Typography>}
                          {item.type === 'thumbnail' && (
                            <Typography variant='caption'>Maximum size is 50Mb. You can upload only 1 file for thumbnail.</Typography>
                          )}

                          <Stack direction='row' spacing={1}>
                            <Stack direction='column' sx={{ flex: 2 }}>
                              <Typography variant='body2'>Attachment type</Typography>
                              <RadioGroup
                                aria-labelledby='attachment-type'
                                value={attachmentType}
                                name='attachment-type'
                                onChange={(e) => setAttachmentType(e.currentTarget.value)}
                              >
                                {item?.options?.map((item_options, item_index) => (
                                  <FormControlLabel
                                    key={item_options.key}
                                    value={item_options.key}
                                    control={<Radio />}
                                    label={
                                      <Typography sx={{ textAlign: 'center', alignItems: 'center' }} variant='body2'>
                                        {item_options.value || item_options.label}
                                      </Typography>
                                    }
                                  />
                                ))}
                              </RadioGroup>
                            </Stack>
                            <Divider orientation='vertical' flexItem />
                            <Stack direction='column' sx={{ flex: 5 }} alignItems='flex-start'>
                              <Typography variant='body2'>Jenis dokumen (document type)</Typography>
                              <RadioGroup
                                aria-labelledby='attachment-doc-type'
                                value={docType}
                                name='attachment-doc-type'
                                onChange={(e) => setDocType(e.currentTarget.value)}
                              >
                                {!_.isEmpty(docs) &&
                                  docs.map((item, index) => (
                                    <FormControlLabel
                                      key={item.key}
                                      value={item.key}
                                      control={<Radio />}
                                      sx={{ marginBottom: 1 }}
                                      label={
                                        <Typography sx={{ textAlign: 'left', alignItems: 'center' }} variant='body2'>
                                          {item.label}
                                        </Typography>
                                      }
                                    />
                                  ))}
                                {/* <FormControlLabel
                                  key='public'
                                  value='public'
                                  control={<Radio />}
                                  label={
                                    <Typography sx={{ textAlign: 'center', alignItems: 'center' }} variant='body2'>
                                      Public
                                    </Typography>
                                  }
                                />
                                <FormControlLabel
                                  key='public'
                                  value='private'
                                  control={<Radio />}
                                  label={
                                    <Typography sx={{ textAlign: 'center', alignItems: 'center' }} variant='body2'>
                                      Private
                                    </Typography>
                                  }
                                /> */}
                              </RadioGroup>
                            </Stack>
                            <Divider orientation='vertical' flexItem />
                            <Stack direction='column' sx={{ flex: 4 }} spacing={1}>
                              <Typography variant='body2'>Attachment description</Typography>
                              <TextField
                                required
                                label='Description'
                                value={attachmentDescription}
                                onChange={(e) => setAttachmentDescription(e.target.value)}
                                fullWidth
                              />
                            </Stack>
                          </Stack>
                          {_.isEmpty(answers[item.tag]?.value) ? (
                            <Typography variant='caption'>No attachment found, you can add your attachment by click the add button below.</Typography>
                          ) : (
                            <Stack direction='row' spacing={2} sx={{ overflow: 'scroll', scrollbarColor: colors.blue[400] }}>
                              {!_.isEmpty(answers[item.tag]?.value) &&
                                answers[item.tag]?.value?.map((item_attachment, index) => (
                                  <Stack key={index} direction='column' alignItems='center'>
                                    <img
                                      alt='cover'
                                      src={item_attachment.path}
                                      width={100}
                                      height={100}
                                      style={{ objectFit: 'cover' }}
                                      onError={(event) => {
                                        event.target.src = '/assets/document_placeholder.jpg';
                                        event.onerror = null;
                                      }}
                                    />
                                    <Stack direction='row' alignItems='center' justifyContent='center'>
                                      <IconButton onClick={() => handleRemoveAttachment(item_attachment.path, item.tag)} aria-label='Delete' color='primary'>
                                        <DeleteIcon sx={{ color: colors.red[400] }} />
                                      </IconButton>
                                      <IconButton onClick={() => window.open(item_attachment.path, '_blank')} aria-label='Delete' color='primary'>
                                        <PreviewIcon sx={{ color: colors.lightBlue[400] }} />
                                      </IconButton>
                                    </Stack>
                                    <Typography variant='caption'>{item_attachment.description}</Typography>
                                  </Stack>
                                ))}
                            </Stack>
                          )}
                          <Stack direction='column' spacing={2} justifyContent='center' alignItems='center'>
                            <Button
                              disabled={!attachmentType || !docType || !attachmentDescription}
                              startIcon={<AddIcon />}
                              onClick={() => {
                                setAttachmentMeta({ ...attachmentMeta, tag: item.tag, length: answers[item.tag]?.value?.length });
                                inputRefs.current[index].click();
                              }}
                            >
                              Add Attachment
                            </Button>
                            <Typography variant='caption'>Please choose attachment type, attachment privacy, and description</Typography>
                            <GeneralLoader isLoading={isLoading && item.tag === attachmentMeta.tag} />
                          </Stack>
                        </Stack>
                      )}
                      {item.type === 'radio' && (
                        <FormControl error={fieldErrors[item.tag]}>
                          <FormLabel id='type'>
                            <Typography variant='caption'>
                              {item.label} {item.isRequired && '*'}
                            </Typography>
                          </FormLabel>
                          <RadioGroup
                            aria-labelledby='demo-radio-buttons-group-label'
                            value={answers[item.tag]?.value}
                            name='radio-buttons-group'
                            required={item.isRequired ? true : false}
                            onChange={(e) => setAnswers({ ...answers, [item.tag]: { value: e.currentTarget.value } })}
                          >
                            {item?.options?.map((item_options, item_index) => (
                              <FormControlLabel
                                key={item_options.key}
                                value={item_options.key}
                                control={<Radio />}
                                label={
                                  <Typography sx={{ textAlign: 'left', alignItems: 'center' }} variant='body2'>
                                    {item_options.value || item_options.label}
                                  </Typography>
                                }
                              />
                            ))}
                          </RadioGroup>
                          <>
                            {answers[item.tag]?.value.includes('other') && (
                              <TextField
                                onChange={(e) => setAnswers({ ...answers, [`${item.tag}_other`]: { value: e.currentTarget.value } })}
                                label={item.options[_.findIndex(item.options, (i) => i.key === 'other')].label}
                              ></TextField>
                            )}
                          </>
                        </FormControl>
                      )}
                      {item.type === 'checkbox' && (
                        <FormControl error={fieldErrors[item.tag]}>
                          <FormLabel id='type'>
                            <Typography variant='caption'>
                              {item.label} {item.isRequired && '*'}
                            </Typography>
                          </FormLabel>

                          <FormGroup error={fieldErrors[item.tag]}>
                            {item?.options?.map((item_options, item_index) => (
                              <FormControlLabel
                                key={item_options.key}
                                control={
                                  // item_options.key.split('_')[1]
                                  <Checkbox
                                    checked={answers[item.tag]?.value.includes(item_options.key)}
                                    onChange={(e) => {
                                      const isChecked = e.target.checked;
                                      const optionKey = item_options.key;
                                      const newArrayValue = answers[item.tag]?.value || [];

                                      if (isChecked) {
                                        newArrayValue.push(optionKey);
                                      } else {
                                        if (newArrayValue.length === 1) {
                                          newArrayValue.splice(0, newArrayValue.length);
                                        } else {
                                          const optionIndex = answers[item.tag]?.value?.indexOf(optionKey);
                                          if (optionIndex !== -1) {
                                            newArrayValue.splice(optionIndex, 1);
                                          }
                                        }
                                      }

                                      setAnswers({ ...answers, [item.tag]: { value: newArrayValue } });
                                    }}
                                  />
                                }
                                label={
                                  <Typography sx={{ textAlign: 'left', alignItems: 'center' }} variant='body2'>
                                    {item_options.value || item_options.label}
                                  </Typography>
                                }
                              />
                            ))}
                          </FormGroup>
                          <>
                            {answers[item.tag]?.value.includes('other') && (
                              <TextField
                                onChange={(e) => setAnswers({ ...answers, [`${item.tag}_other`]: { value: e.currentTarget.value } })}
                                label={item.options[_.findIndex(item.options, (i) => i.key === 'other')].label}
                              ></TextField>
                            )}
                          </>
                        </FormControl>
                      )}
                      {item.type === 'location' && (
                        <Stack direction='column' spacing={1} sx={{ overflow: 'scroll', minHeight: 300 }}>
                          <Stack direction='column' spacing={1} mb={2}>
                            <Typography variant='body2'>Pilih lokasi (Choose location)</Typography>
                          </Stack>

                          <Stack direction='column' spacing={1}>
                            <Autocomplete
                              ListboxProps={{ style: { maxHeight: 150 } }}
                              disablePortal
                              disabled={_.isEmpty(provinces)}
                              id='combo-box-provinces'
                              options={provinces}
                              sx={{ width: 400 }}
                              renderInput={(params) => <TextField {...params} label='Pilih provinsi (choose province)' />}
                              required
                              onChange={(event, newValue) => {
                                if (!newValue)
                                  return setFormLocation({
                                    ...formLocation,
                                    province: { id: '', label: '', input_value: '' },
                                    city: { id: '', label: '', input_value: '' },
                                  });
                                setFormLocation({ ...formLocation, province: { id: newValue.id, label: newValue.label, input_value: newValue.label } });
                              }}
                              value={formLocation?.province?.label}
                              inputValue={formLocation?.province?.input_value}
                              onInputChange={(event, newInputValue) => {
                                setFormLocation({ ...formLocation, province: { ...formLocation.province, input_value: newInputValue } });
                              }}
                            />
                          </Stack>
                          <Stack direction='column' spacing={1}>
                            <Autocomplete
                              ListboxProps={{ style: { maxHeight: 150 } }}
                              required
                              disabled={_.isEmpty(cities)}
                              disablePortal
                              id='combo-box-cities'
                              options={cities}
                              sx={{ width: 400 }}
                              renderInput={(params) => <TextField {...params} label='Pilih kabupaten/kota (choose city/district)' />}
                              onChange={(event, newValue) => {
                                if (!newValue) return setFormLocation({ ...formLocation, city: { id: '', label: '', input_value: '' } });
                                setFormLocation({ ...formLocation, city: { id: newValue.id, label: newValue.label } });
                              }}
                              value={formLocation?.city?.label}
                              inputValue={formLocation?.city?.input_value}
                              onInputChange={(event, newInputValue) => {
                                setFormLocation({ ...formLocation, city: { ...formLocation.city, input_value: newInputValue } });
                              }}
                            />
                          </Stack>
                          <Stack direction='column' spacing={2} justifyContent='center' alignItems='flex-start' m={2} p={2}>
                            {answers[item.tag]?.value && (
                              <>
                                <Typography>Selected location:</Typography>
                                {answers[item.tag]?.value?.map((item_options, index_options) => (
                                  <Stack direction='row' spacing={1} alignItems='center'>
                                    <IconButton
                                      aria-label='Delete'
                                      color='primary'
                                      onClick={() => {
                                        const currentValues = answers[item.tag]?.value;
                                        currentValues.splice(index_options, 1);
                                        setAnswers({ ...answers, [item.tag]: { value: currentValues } });
                                      }}
                                    >
                                      <DeleteIcon sx={{ color: colors.red[400] }} />
                                    </IconButton>
                                    <Typography sx={{ fontWeight: '700' }}>
                                      Province: {item_options?.province?.label}, City/District: {item_options.city?.label}
                                    </Typography>
                                  </Stack>
                                ))}
                              </>
                            )}
                          </Stack>
                          <Stack direction='column' spacing={2} justifyContent='center' alignItems='center'>
                            <Button
                              disabled={!formLocation?.province?.id}
                              startIcon={<AddIcon />}
                              onClick={() => {
                                const values = !_.isEmpty(answers[item.tag]?.value) ? answers[item.tag]?.value : [];
                                values.push(formLocation);
                                setAnswers({ ...answers, [item.tag]: { value: values } });
                                setFormLocation({
                                  ...formLocation,
                                  province: { id: '', label: '', input_value: '' },
                                  city: { id: '', label: '', input_value: '' },
                                });
                              }}
                            >
                              Add Location
                            </Button>
                            <Typography variant='caption'>
                              Please choose province and city/district then click add location to save your location selection
                            </Typography>
                            <GeneralLoader isLoading={isLoading && item.tag === attachmentMeta.tag} />
                          </Stack>
                        </Stack>
                      )}
                      {/* <Typography variant='caption'>{JSON.stringify(item)}</Typography> */}
                    </Stack>
                  </Card>
                )}
              </>
            ))}

          {!_.isEmpty(metadata) && answers?.type_of_gp?.value === 'sdg_awards' && isFunctionEligible(decoded.type, 'update_rank_flag') && (
            <Card sx={cardStyle}>
              <Stack direction='column' sx={{ minWidth: '100vh' }} p={1}>
                {!_.isEmpty(metadata) && (
                  <Stack direction='column' sx={{ flex: 5 }} alignItems='flex-start'>
                    <Typography variant='body2'>Rank Flag</Typography>
                    <RadioGroup aria-labelledby='rank_flag' value={rankFlag} name='doc_status' onChange={(e) => setRankFlag(e.currentTarget.value)}>
                      <FormControlLabel
                        key='1'
                        value='1'
                        control={<Radio />}
                        label={
                          <Typography sx={{ textAlign: 'center', alignItems: 'center' }} variant='body2'>
                            Rank 1
                          </Typography>
                        }
                      />
                      <FormControlLabel
                        key='2'
                        value='2'
                        control={<Radio />}
                        label={
                          <Typography sx={{ textAlign: 'center', alignItems: 'center' }} variant='body2'>
                            Rank 2
                          </Typography>
                        }
                      />
                      <FormControlLabel
                        key='3'
                        value='3'
                        control={<Radio />}
                        label={
                          <Typography sx={{ textAlign: 'center', alignItems: 'center' }} variant='body2'>
                            Rank 3
                          </Typography>
                        }
                      />
                      <FormControlLabel
                        key='4'
                        value='4'
                        control={<Radio />}
                        label={
                          <Typography sx={{ textAlign: 'center', alignItems: 'center' }} variant='body2'>
                            Rank 4
                          </Typography>
                        }
                      />
                      <FormControlLabel
                        key='5'
                        value='5'
                        control={<Radio />}
                        label={
                          <Typography sx={{ textAlign: 'center', alignItems: 'center' }} variant='body2'>
                            Rank 5
                          </Typography>
                        }
                      />
                    </RadioGroup>
                  </Stack>
                )}
              </Stack>
            </Card>
          )}

          {/* {!_.isEmpty(metadata) && isFunctionEligible(decoded.type, 'update_document_status') && (
            <Card sx={cardStyle}>
              <Stack direction='column' sx={{ minWidth: '100vh' }} p={1}>
                {!_.isEmpty(metadata) && (
                  <Stack direction='column' sx={{ flex: 5 }} alignItems='flex-start'>
                    <Typography variant='body2'>Document Status</Typography>
                    <RadioGroup aria-labelledby='doc_status' value={docStatus} name='doc_status' onChange={(e) => setDocStatus(e.currentTarget.value)}>
                      <FormControlLabel
                        key='new'
                        value='new'
                        control={<Radio />}
                        label={
                          <Typography sx={{ textAlign: 'center', alignItems: 'center' }} variant='body2'>
                            New
                          </Typography>
                        }
                      />
                      <FormControlLabel
                        key='under_review'
                        value='under_review'
                        control={<Radio />}
                        label={
                          <Typography sx={{ textAlign: 'center', alignItems: 'center' }} variant='body2'>
                            Under Review
                          </Typography>
                        }
                      />
                      <FormControlLabel
                        key='reviewed'
                        value='reviewed'
                        control={<Radio />}
                        label={
                          <Typography sx={{ textAlign: 'center', alignItems: 'center' }} variant='body2'>
                            Reviewed
                          </Typography>
                        }
                      />
                      <FormControlLabel
                        key='published'
                        value='published'
                        control={<Radio />}
                        label={
                          <Typography sx={{ textAlign: 'center', alignItems: 'center' }} variant='body2'>
                            Published
                          </Typography>
                        }
                      />
                    </RadioGroup>
                  </Stack>
                )}
              </Stack>
            </Card>
          )} */}

          {type !== 'trackChange' && (
            <Stack direction='row' sx={{ width: '100%' }}>
              {!_.isEmpty(headers) && isFunctionEligible(userInfo.type, 'button_form_update') && (
                <Stack direction='row' justifyContent='flex-start' m={2}>
                  <LoadingButton loading={isLoading} onClick={handleSubmit} variant='contained' sx={{ color: '#FFFFFF', width: 100 }}>
                    {type === 'moderation' ? 'UPDATE' : 'SUBMIT'}
                  </LoadingButton>
                </Stack>
              )}

              {!_.isEmpty(headers) && isFunctionEligible(userInfo.type, 'button_form_delete') && (
                <Stack direction='row' justifyContent='flex-start' m={2}>
                  <LoadingButton
                    loading={isLoading}
                    onClick={(e) => setAnchor(e.currentTarget)}
                    variant='contained'
                    sx={{ color: '#FFFFFF', width: 100, backgroundColor: colors.red[400] }}
                  >
                    DELETE
                  </LoadingButton>
                </Stack>
              )}
            </Stack>
          )}
          {/* <Stack direction='column' spacing={2} alignItems='center' justifyContent='center' sx={{ width: '100vw', height: 200 }}>
            <Stack direction='column'>
              <Typography variant='body2' sx={{ fontWeight: 700 }} color='softblack'>
                Indonesia's SDG Best Practices, Stories, and Documents Repository
              </Typography>
            </Stack>
            <Stack direction='row' spacing={2} alignItems='center'>
              <Stack>
                <img alt='logo sdg Indonesia' src='/assets/logo_sdg_indonesia_new.png' width={100} height='auto'></img>
              </Stack>
              <Stack>
                <img alt='logo bappenas' src='/assets/bappenas_logo_square.png' width={100} height='auto'></img>
              </Stack>
              <Stack>
                <img alt='logo UN Indonesia' src='/assets/logo_un_indonesia.png' width={100} height='auto'></img>
              </Stack>
            </Stack>
          </Stack> */}
        </Stack>
      </Container>
      <DialogHTMLEditor dialogMetadata={openDialogHTMLEditor} handleClose={handleDialogClose} setAnswers={setAnswers} answers={answers} />
      <Popover
        id='Popup'
        open={Boolean(anchor)}
        anchorEl={anchor}
        onClose={() => setAnchor(null)}
        anchorOrigin={{
          vertical: 'left',
          horizontal: 'left',
        }}
      >
        <Stack direction='column' sx={{ backgroundColor: colors.white, width: 300, padding: 2 }} spacing={1}>
          <Typography>Are you sure want to delete this data?</Typography>
          <Stack direction='row' spacing={1}>
            <Button onClick={doDeleteRepo} variant='contained'>
              Yes
            </Button>
            <Button onClick={() => setAnchor(null)} variant='outlined'>
              No
            </Button>
          </Stack>
        </Stack>
      </Popover>
    </Box>
  );
};

export default QuestionForm;
